import styled from 'styled-components'
import { ButtonHTMLAttributes, FC } from 'react'
import { COLORS } from '../../assets/styles/colors'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	height?: number
	width?: number
}

export const BlueTransparentButton: FC<ButtonProps> = styled.button`
	height: ${props => props.height || 40}px;
	width: ${props => props.width + 'px' || 'full'};
	color: ${COLORS.DECORATIVE_MEDIUM_BLUE};
	background: none;
	border: 1px solid ${COLORS.DECORATIVE_MEDIUM_BLUE};
	border-radius: 20px;
	font-size: 15px;
	font-weight: 500;

	&:disabled {
		opacity: 0.4;
		cursor: not-allowed;
	}
`
